import React from 'react';
import type { Permission } from '../data/models/permission.model';
import { useAppSelector } from './useAppSelector';
import * as userSlice from '../data/user.slice';
import { useHasPermission } from './permissions/useHasPermission';

export const useIsTestUser = (): boolean => {
  const [isTestUser, setIsTestUser] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const isProviderTestUserAll: Permission = {
    resource: 'providers',
    action: 'test',
    scope: 'all',
  };

  const isTestUserAll = useHasPermission(user, isProviderTestUserAll);

  React.useEffect(() => {
    setIsTestUser(isTestUserAll);
  }, [isTestUserAll]);

  return isTestUser;
};
